import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const RSETH_URL = 'https://universe.kelpdao.xyz/rseth/totalApy'

export const rsethFetcher: YieldFetcher = {
  label: 'RSETH',
  fetch: async () => {
    const res = await fetch(RSETH_URL).then((r) => r.json())
    return { RSETH: apyToAprPercent(res.totalAPY) }
  },
}
